const KEY = 'gisify_anon_id'
const UUID_V4 = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

export function getOrMintAnonymousId(): string {
  try {
    const cached = localStorage.getItem(KEY)
    if (cached && UUID_V4.test(cached)) return cached
    const fresh = crypto.randomUUID()
    localStorage.setItem(KEY, fresh)

    return fresh
  } catch {
    return crypto.randomUUID()
  }
}

/** Mint a fresh anonymous ID and write it to storage. Call on auth state
 * transitions (login + logout) to invalidate the API Gateway custom
 * authorizer's per-UUID cache: that cache keys on `X-Anonymous-Identity`
 * only, so reusing a UUID across guest→authed (or authed→guest) flips can
 * serve a stale `caller.kind` decision to the layers / csv-tables / dashboard
 * mixed-auth handlers for the cache TTL (~5 min). */
export function rotateAnonymousId(): string {
  const fresh = crypto.randomUUID()

  try {
    localStorage.setItem(KEY, fresh)
  } catch {
    /* ignore — getOrMintAnonymousId falls back to in-memory uuids when storage is unavailable */
  }

  return fresh
}
